import BottomSheet from '@gorhom/bottom-sheet'
import type { PropsWithChildren } from 'react'
import type { CardActivityFeedBottomSheetHeightStore } from './useCardActivityFeedBottomSheetHeightStore'
import { maxWidth, useMainWrapperPadding } from '@/src/common/wrappers/MainWrapper'
import { useMediaQuery } from 'react-responsive'
import { useIsTabBarPositionedTop } from '@/src/common/components/TopTabBar'
import { useCardManagementModuleMarginVertical } from '@/src/common/modules/CardManagementModule'
import { mesaColorNames, classes } from '@/src/common/theme'

export interface CardActivityFeedBottomSheetProps extends PropsWithChildren {
  cardActivityFeedBottomSheetHeightStore: CardActivityFeedBottomSheetHeightStore
}

export function useIsCardActivityFeedBottomSheetFullHeight() {
  return !useMediaQuery({ maxWidth: 720 })
}

export function CardActivityFeedBottomSheet({
  cardActivityFeedBottomSheetHeightStore: { handleHeight, animatedIndex, minHeight, maxHeight },
  children,
}: CardActivityFeedBottomSheetProps) {
  const isCardActivityFeedBottomSheetFullHeight = useIsCardActivityFeedBottomSheetFullHeight()
  const mainWrapperPadding = useMainWrapperPadding()
  const isTabBarPositionedTop = useIsTabBarPositionedTop()
  const cardManagementModuleMarginVertical = useCardManagementModuleMarginVertical()

  return (
    <BottomSheet
      enableDynamicSizing={false}
      animatedIndex={animatedIndex}
      snapPoints={
        isCardActivityFeedBottomSheetFullHeight
          ? [maxHeight - (isTabBarPositionedTop ? 2 * cardManagementModuleMarginVertical : 0)]
          : [minHeight, maxHeight]
      }
      enableContentPanningGesture={false}
      containerStyle={{ marginHorizontal: 'auto', maxWidth }}
      style={[
        { backgroundColor: 'transparent', marginHorizontal: 16 },
        isCardActivityFeedBottomSheetFullHeight && {
          width: '42%',
          marginLeft: 'auto',
          maxWidth: maxWidth / 2,
          marginRight: mainWrapperPadding,
        },
      ]}
      handleIndicatorStyle={isCardActivityFeedBottomSheetFullHeight && { display: 'none' }}
      enableHandlePanningGesture={!isCardActivityFeedBottomSheetFullHeight}
      handleStyle={{
        backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
        height: isCardActivityFeedBottomSheetFullHeight ? 0 : handleHeight,
        alignItems: 'center',
        justifyContent: 'center',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        cursor: isCardActivityFeedBottomSheetFullHeight ? 'auto' : undefined,
      }}
      backgroundStyle={{
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        ...classes.cardShadow,
      }}
    >
      {children}
    </BottomSheet>
  )
}
